import { ArticleRepository } from "@/core/repositories/article.repository";
import { EventRepository } from "@/core/repositories/event.repository";
import { FeedbackRepository } from "@/core/repositories/feedback.repository";
import { FirebaseUserRepository } from "@/core/repositories/firebase-user.repository";
import { LegalRepository } from "@/core/repositories/legal.repository";
import { MediaRepository } from "@/core/repositories/media.repository";
import { PlaceRepository } from "@/core/repositories/place.repository";
import { TaxonomyRepository } from "@/core/repositories/taxonomy.repository";
import { TeamRepository } from "@/core/repositories/team.repository";
import { ArticleService } from "@/core/services/article.service";
import { EventService } from "@/core/services/event.service";
import { FeedbackService } from "@/core/services/feedback.service";
import { FirebaseUserService } from "@/core/services/firebase-user.service";
import { GooglePlacesService } from "@/core/services/google-places.service";
import { LegalService } from "@/core/services/legal.service";
import { MediaService } from "@/core/services/media.service";
import { PlaceService } from "@/core/services/place.service";
import { TaxonomyService } from "@/core/services/taxonomy.service";
import { TeamService } from "@/core/services/team.service";

export function createArticleService() {
  const mediaRepository = new MediaRepository();
  return new ArticleService(new ArticleRepository(), new MediaService(mediaRepository));
}

export function createMediaService() {
  return new MediaService(new MediaRepository());
}

export function createEventService() {
  const mediaRepository = new MediaRepository();
  return new EventService(new EventRepository(), new MediaService(mediaRepository));
}

export function createPlaceService() {
  const mediaRepository = new MediaRepository();
  return new PlaceService(
    new PlaceRepository(),
    new MediaService(mediaRepository),
    new EventRepository(),
  );
}

export function createGooglePlacesService() {
  return new GooglePlacesService();
}

export function createTaxonomyService() {
  return new TaxonomyService(new TaxonomyRepository());
}

export function createTeamService() {
  return new TeamService(new TeamRepository());
}

export function createLegalService() {
  return new LegalService(new LegalRepository());
}

export function createFirebaseUserService() {
  return new FirebaseUserService(new FirebaseUserRepository());
}

export function createFeedbackService() {
  return new FeedbackService(new FeedbackRepository());
}
